import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useRef } from "react";
import { useAssignment } from "../../../Hooks/assignment";
import { useStyles } from "./styles";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { color } from "../../../assets/const/color";
import { useNavigate } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { scrolltoView } from "../../../Utils/scrollToView";
import CustomPagination from "../../../common/Pagination";
import usePagination from "../../../common/usePagination";
import { useCallback } from "react";
import useAuthStore from "../../../Hooks/auth";
import ToggleSwitch from "../../../common/ToggleSwitch";

const Assignment = () => {
  const classes = useStyles();
  const {
    assignments,
    getAssignmentAction,
    deleteAssignmentAction,
    setCurrentAssignmentAction,
    resetCurrentAssignmentAction,
    setRedirectAction,
    perPage,
    page,
    setPageAction,
    setOffsetAction,
    setPerPageAction,
    offset,
  } = useAssignment();
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [currentId, setCurrentId] = React.useState("");
  const tableRef = useRef();
  const { institutionId } = useAuthStore();
  const navigate = useNavigate();

  const handlePage = (e) => {
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
  };

  const count =
    assignments?.classAssignment && Math.ceil(assignments?.totalNoOfRecordsForAssignment?.totalNoOfRecords / perPage);
  const _DATA = usePagination(assignments?.classAssignment, perPage);

  const handleChange = useCallback(
    (e, p) => {
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
      _DATA.jump(p);
    },
    [perPage, page]
  );

  React.useEffect(() => {
    getAssignmentAction({
      limit: perPage,
      offset: offset,
      institutionId
    });
  }, [perPage, offset]);

  const handleToggle =(e,ID,status)=>{
    if (status === "InActive") {
      deleteAssignmentAction({
        id: ID,
        status: "Active"
      });
    }
    if (status === "Active") {
      deleteAssignmentAction({
        id: ID,
        status: "InActive"
      })
    }
  }

  const handleExpand = (state, id) => {
    if (currentId === id) {
      setIsExpanded(state);
    } else {
      setIsExpanded(true);
    }
    setCurrentId(id);
  };

  const ExpandComponent = (props) => {
    const { _el } = props;
    return (
      <React.Fragment>
        <TableCell colSpan={5}>
          <Stack sx={{ pb: 2 }}>
            <Typography sx={{ fontFamily: "inter" }}>
              Description : {_el.description}
            </Typography>
            <Typography sx={{ fontFamily: "inter" }}>
              Email : {_el.email}
            </Typography>
          </Stack>
          <Stack sx={{ flexDirection: "row" }} gap={3}>
            <Button
              className={classes.greenBtn}
              onClick={() => {
                setCurrentAssignmentAction(_el.id);
                setRedirectAction(false);
                navigate("/assignment/edit");
              }}
            >
              Edit
            </Button>
            {/* <Button
              className={classes.remove_btn}
              onClick={() => {
                deleteAssignmentAction(_el.id);
              }}
            >
              Delete
            </Button> */}
          </Stack>
        </TableCell>
      </React.Fragment>
    );
  };

  const ExpandableTableRow = ({ children, expandComponent, ...otherProps }) => {
    //console.log("otherprops", otherProps);
    return (
      <>
        <TableRow {...otherProps}>{children}</TableRow>
        {expandComponent.props._el.id === currentId && isExpanded && (
          <TableRow sx={{ background: "#D6F7ED" }}>{expandComponent}</TableRow>
        )}
      </>
    );
  };

  // React.useEffect(() => {
  //   tableRef.current?.scrollIntoView({ behavior: "smooth" });
  // }, [isExpanded]);

  return (
    <React.Fragment>
      <Stack
        sx={{
          pb: 3,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          "& .MuiButton-root:hover": {
            background: `${color.lightGreen} !important`,
            color: `${color.white} !important`,
          },
        }}
      >
        <Typography
          sx={{
            fontFamily: "inter",
            fontSize: "18px !important",
            fontWeight: "700 !important",
            color: "#00473E",
          }}
        >
          Assignment List
        </Typography>
        <Stack>
          <Button
            className={classes.greenBtn}
            onClick={() => {
              resetCurrentAssignmentAction();
              navigate("/assignment/add");
              setRedirectAction(false);
            }}
          >
            Add Assignment
          </Button>
        </Stack>
      </Stack>
      <Stack className={classes.assignment}>
        <TableContainer sx={{ maxHeight: 500 }}>
          <Table
            className={classes.table}
            aria-label="simple table"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                <TableCell>Department</TableCell>
                <TableCell align="center">Class Date</TableCell>
                <TableCell align="center">Type of Assignment</TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center">Status</TableCell>
              </TableRow>
            </TableHead>
            {assignments?.classAssignment?.length > 0 ? (
              assignments?.classAssignment?.map((_el, index) => (
                <TableBody
                  sx={{
                    background: currentId === _el.id && isExpanded && "#D6F7ED",
                  }}
                  key={index}
                  ref={tableRef}
                  id={`assignmentUnique${index + 1}`}
                >
                  <ExpandableTableRow
                    key={_el.id}
                    expandComponent={<ExpandComponent _el={_el} />}
                    style={{ cursor: "pointer" }}
                  >
                    <TableCell>{_el.departmentName}</TableCell>
                    <TableCell component="th" scope="row">
                      <Stack
                        sx={{
                          flexDirection: "row",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{ fontFamily: "inter", fontSize: "inherit" }}
                        >
                          {_el.classDate}
                        </Typography>
                        <Stack sx={{ ml: 3 }}>
                          <CalendarMonthIcon
                            sx={{ fill: "#71717A", fontSize: "22px" }}
                          />
                        </Stack>
                      </Stack>
                    </TableCell>
                    <TableCell component="th" align="center">
                      <Stack
                        sx={{
                          flexDirection: "row",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{ fontFamily: "inter", fontSize: "inherit" }}
                        >
                          {_el.typeOfAssignment}
                        </Typography>
                        <Stack sx={{ ml: 3 }}>
                          {currentId === _el.id && isExpanded ? (
                            <KeyboardArrowUpIcon
                              onClick={() => {
                                handleExpand(!isExpanded, _el.id);
                                scrolltoView(`assignmentUnique${assignments?.classAssignment?.length}`);
                              }}
                              sx={{ fill: color.lightGreen, fontSize: "22px" }}
                            />
                          ) : (
                            <KeyboardArrowDownIcon
                              onClick={() => {
                                handleExpand(!isExpanded, _el.id);
                                scrolltoView(`assignmentUnique${assignments?.classAssignment?.length}`);
                              }}
                              sx={{ fill: color.lightGreen, fontSize: "22px" }}
                            />
                          )}
                        </Stack>
                      </Stack>
                    </TableCell>
                    <TableCell align="center">{_el.semesterName}</TableCell>
                    <TableCell align="center">
                      <Stack
                        sx={{
                          alignItems: "center",
                          cursor: "pointer",
                          zIndex: 1,
                          position: "relative",
                        }}
                        onClick={(e)=>handleToggle(e,_el.id,_el.status)}
                      >
                        <ToggleSwitch
                          defaultChecked
                          checked={_el.status  === "Active" ? true : false}
                        />
                      </Stack>
                    </TableCell>
                  </ExpandableTableRow>
                </TableBody>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} sx={{ borderBottom: "none" }}>
                  <Stack
                    sx={{
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    No Data
                  </Stack>
                </TableCell>
              </TableRow>
            )}
          </Table>
        </TableContainer>
        {assignments?.totalNoOfRecordsForAssignment?.totalNoOfRecords > 10 && (
          <CustomPagination
            count={count}
            page={page}
            onPageChange={handleChange}
            handlePage={handlePage}
            perPage={perPage}
          />
        )}
      </Stack>
    </React.Fragment>
  );
};

export default Assignment;
